import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/index.css";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { TopBar } from "@/components/Layout/TopBar";
import { Header } from "@/components/Layout/Header";
import { Footer } from "@/components/Layout/Footer";
import { FloatingWhatsapp } from "@/components/Layout/FloatingWhatsapp";
import Home from "@/pages/Home";
import ParcoVeicoli from "@/pages/ParcoVeicoli";
import VehicleDetail from "@/pages/VehicleDetail";
import Azienda from "@/pages/Azienda";
import VendiAuto from "@/pages/VendiAuto";
import Contatti from "@/pages/Contatti";
import Noleggio from "@/pages/Noleggio";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const ScrollTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollTop />
        <TopBar />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/parco-veicoli" element={<ParcoVeicoli />} />
            <Route path="/veicolo/:id" element={<VehicleDetail />} />
            <Route path="/azienda" element={<Azienda />} />
            <Route path="/vendi-auto" element={<VendiAuto />} />
            <Route path="/noleggio" element={<Noleggio />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </main>
        <Footer />
        <FloatingWhatsapp />
        <Toaster theme="dark" position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
